export default {
    state: {
        list: null,

        count: null,

        filters: {
            hook: null,
            onlyFails : false
        },
    },

    mutations: {
        INTEGRATIONSREPORT_SET_LIST(state, list) {
            state.list = list
        },

        INTEGRATIONSREPORT_SET_COUNT(state, count) {
            state.count = count
        },

        INTEGRATIONSREPORT_SET_FILTER(state, {key, value}) {
            state.filters = {
                ...state.filters,
                [key]: value
            }
        },

        INTEGRATIONSREPORT_RESET_FILTERS(state){
            state.filters = {
                hook: null,
                onlyFails : false
            }
        },

    },
}
